module.exports = __webpack_public_path__ + "img/网站系统定制.7076372d.png";